export interface WebhooksState {
	currentWebhook: WebhookItem;
	currentWebhookAttempts: WebhookAttempt;
	webhooks: Webhook;
	viewing: string;
	totalAttempts: number;
	totalSucceededAttempts: number;
	totalFailedAttempts: number;
}

export interface Webhook {
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	items: WebhookItem[];
	pageIndex: number;
	totalItems: number;
	totalPages: number;
}

export interface WebhookItem {
	event: WebhookEvent;
	id?: string;
	name: string;
	description?: string;
	mode?: string;
	url: string;
	enabled?: boolean;
	secret?: string;
	contentType?: string;
	useContentType?: boolean;
}

export interface WebhookAttempt {
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	items: WebhookAttemptItem[];
	pageIndex: number;
	totalItems: number;
	totalPages: number;
}

export interface WebhookAttemptItem {
	id: string;
	hookId: string;
	successful: boolean;
	responseStatusCode: string;
	responseContent: string;
	requestContent: string;
	invokedAt: string;
}

export interface WebhookDropdownItem {
	label: string;
	value: WebhookEvent;
}

export interface FetchPaginatedPayload {
	pageIndex: number;
	filterParam: string;
}

export enum WebhookEvent {
	APPLICANT_REVIEWED = 1,
	APPLICANT_PROCESSED = 2,
	APPLICANT_CREATED = 3,
	APPLICANT_APPROVED = 5,
	APPLICANT_REJECTED = 6,
	COMPANY_CREATED = 7,
	COMPANY_DOCUMENT_PROCESSED = 8,
	COMPANY_APPROVED = 9,
	COMPANY_REJECTED = 10,
	APPLICANT_OVERIDE = 11,
	APPLICANT_REQUIRES_REVIEW = 12,
}
